import colorPalette from '@/xvisor/constants/colorPalette';
import colorPaletteShade from '@/xvisor/constants/colorPaletteShade';

const COLORS = [
  colorPaletteShade.yellow4,
  colorPaletteShade.teal4,
  colorPaletteShade.green4,
  colorPaletteShade.blue4,
  colorPaletteShade.indigo4,
  colorPaletteShade.purple4,
  colorPaletteShade.pink4,
  colorPaletteShade.gray4,
  colorPaletteShade.teal6,
  colorPaletteShade.yellow6,
  colorPaletteShade.green6,
  colorPaletteShade.blue6,
  colorPaletteShade.indigo6,
  colorPaletteShade.purple6,
  colorPaletteShade.pink6,
  colorPaletteShade.gray6,
  colorPalette.darkPink,
];

export default {
  data() {
    return {
      chartOptionsTemplate: {
        tooltip: {},
        legend: [
          {
            show: false,
            textStyle: {
              color: '',
            },
            right: 0,
            orient: 'vertical',
            top: 200,
          },
        ],
        animationDuration: 1500,
        animationEasingUpdate: 'quinticInOut',
        series: [
          {
            type: 'graph',
            layout: 'none',
            color: COLORS,
            symbolSize: 18,
            data: null,
            links: null,
            categories: null,
            roam: true,
            label: {
              position: 'right',
              formatter: '{b}',
            },
            lineStyle: {
              color: 'source',
              curveness: 0.15,
            },
            emphasis: {
              focus: 'adjacency',
              lineStyle: {
                width: 10,
              },
            },
          },
        ],
      },
    };
  },
  methods: {
    formattedNode(node) {
      return {
        x: node.coordinate.x,
        y: node.coordinate.y,
        id: node.id,
        name: node.name,
        category: node.deviceType,
        type: node.type,
        symbol: node.deviceType === 'endpoint' ? 'circle' : 'diamond',
        symbolSize: node.deviceType === 'endpoint' ? 18 : 30,
        tooltip: {
          formatter: () => {
            const rows = [
              `Ip: ${node.name}`,
              `Device Type: ${node.deviceType}`,
            ].join('<br />');
            return `<div class="apache-echarts-tooltip">${rows}</div>`;
          },
        },
      };
    },
  },
};
